// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

import { hasPermissions } from 'src/module/authentication/selector';
import { useSelector } from 'react-redux';

export default function PermissionFence (props) {
  const {
    can,
    noPermissionComponent,
    children
  } = props;
  const render: boolean = useSelector(hasPermissions(can));

  if (render) {
    return  children;
  }
  if (noPermissionComponent) {
    return noPermissionComponent;
  }
  return null;
}

PermissionFence.propTypes = {
  can: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]).isRequired,
  noPermissionComponent: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

PermissionFence.defaultProps = {
};
